import toastr from 'toastr';
import Choices from 'choices.js';
import { ajax } from 'jquery';

toastr.options = {
    "positionClass": "toast-bottom-left",
    "progressBar": true,
    "showDuration": "300",
    "showEasing": "swing",
    "showMethod": "fadeIn",
    "hideMethod": "fadeOut",
};

const ajaxUrl = $('.featured-product-select').data('ajaxUrl');

const initChoices = () => {
    const choices = new Choices('.featured-product-select', {
        searchEnabled: true,
        searchResultLimit: 10,
        searchPlaceholderValue: 'Zoek een product',
        loadingText: 'Laden...',
        noResultsText: 'Geen resultaten gevonden',
        shouldSort: false,
        itemSelectText: '',
    });

    $('.featured-product-select').on('search', (event) => {
        const query = event.detail.value;

        ajax({
            type: 'GET',
            url: ajaxUrl,
            data: { search: query, action: 'searchproduct', format: 'select' },
            dataType: 'json',
            success: (response) => {
                if (response && response.results) {
                    const options = response.results.map((item) => ({
                        value: item.id,
                        label: item.text,
                    }));
                    choices.setChoices(options, 'value', 'label', true);
                } else {
                    toastr.error('Ongeldig antwoord van de server.');
                }
            },
            error: (error) => {
                toastr.error('Er is een fout opgetreden. Probeer het later opnieuw.');
                console.error('AJAX error:', error.responseText || error.statusText || error);
            },
        });
    });
};

const updateProductMeta = (productId, enable) => {
    checkIfProductIsFeatured(productId, function(isFeatured) {
        if (isFeatured && enable) {
            toastr.warning('Dit product is al uitgelicht.');
        } else {
            ajax({
                url: ajaxUrl,
                method: 'POST',
                data: {
                    action: 'update_featured_product',
                    product_id: productId,
                    enable: enable,
                },
                success: function (response) {
                    if (response.success) {
                        $('.featured-post-container').html(response.data.html);
                        if (enable) {
                            toastr.success('Product is toegevoegd als uitgelicht product');
                        } else {
                            toastr.success('Product is verwijderd als uitgelicht product');
                        }
                    } else {
                        toastr.error('Er is een fout opgetreden. Probeer het later opnieuw.');
                        console.error('Update product meta error:', response);
                    }
                },
                error: function (response) {
                    toastr.error('Er is een fout opgetreden. Probeer het later opnieuw.');
                    console.error('Update product meta error:', response);
                    console.error('Error details:', response.responseText);
                },
            });
        }
    });
};

const checkIfProductIsFeatured = (productId, callback) => {
    ajax({
        url: ajaxUrl,
        method: 'POST',
        data: {
            action: 'check_featured_product',
            product_id: productId,
        },
        success: function (response) {
            if (response.success) {
                callback(response.data.is_featured);
            } else {
                toastr.error('Er is een fout opgetreden. Probeer het later opnieuw.');
                console.error('Check featured product error:', response);
                callback(false);
            }
        },
        error: function (response) {
            toastr.error('Er is een fout opgetreden. Probeer het later opnieuw.');
            console.error('Check featured product error:', response);
            callback(false);
        },
    });
};

$(document).ready(function () {
    if ($('.featured-product-select').length) {
        initChoices();
    }

    $(document).on('submit', '.featured-products', function (e) {
        e.preventDefault();
        const productId = $('.featured-product-select').val();
        if (productId) {
            updateProductMeta(productId, true);
        }
    });

    $(document).on('submit', '.edit-featured-item', function(e) {
        e.preventDefault();

        const price = $(this).find('.featured-item-price').val();
        const itemPrice = $(this).data('current-price');
        const post = $(this).data('post');

        if(Number(price) < Number(itemPrice)) {
            toastr.error(`De prijs mag niet lager zijn dan de huidige prijs: ${itemPrice}`);
            if(Number(price) != '') {
                return;
            }
        }

        $.ajax({
            url: ajaxUrl,
            method: 'POST',
            data: {
                action: 'update_featured_product_price',
                price: price,
                post: post,
            },
            success: function () {
                toastr.success('Prijs is geupdate');
            },
            error: function () {
                toastr.error('Er is een fout opgetreden. Probeer het later opnieuw.');
            },
        });
    });

    $(document).on('click', '.featured-item-delete', function(e) {
        e.preventDefault();

        const post = $(this).data('post');

        updateProductMeta(post, false);
    });

    $('.submit-featured').on('click', function () {
        var product_id = $(this).attr('data-product');
        var quantity = $('#quantity_featured_' + product_id).val();

        var data = {
            'product_id': product_id,
            'quantity': quantity,
        };

        $.post('/?add-to-cart=' + product_id, data, function () {
            const ajaxUrl = $('.module--favorites__items--items').data('ajax');

            $.ajax({
                type: "POST",
                url: ajaxUrl,
                data: {
                    action: 'reload_favorites',
                },
                success: function (response) {
                    $('.module--favorites__items--items').empty();
                    $('.module--favorites__items--items').html(response);

                    toastr.success('Product toegevoegd aan winkelmand');
                    $('#quantity_featured_' + product_id).val(0);
                },
                error: function (error) {
                    toastr.error('Er is een fout opgetreden. Probeer het later opnieuw.');
                    console.error('Reload favorites error:', error);
                },
            });
        });
    });

    $(document).on('click', '.featured-product-add', function (e) {
        e.preventDefault();
        $('.featured-products').submit();
    });
});